import { CashbackRepositoryAPI } from "@/AutoEnrollment/application/CashbackAutoEnrollments"
import { LogaltyModel } from "@/Logalty/domain"
import { HttpMethod, MetaStatusCodes } from "@/Shared/domain"
import { axiosFetch } from "@/Shared/infrastructure"
import { logout } from "@/Shared/infrastructure/endpoints"
import { useMetaResponseHandler } from "@/Shared/ui/form"
import { useLoader } from "@/Shared/ui/loader"
import { useUserData } from "@/User/ui/context"

interface ICashbackAutoEnrollmentController {
  initCashbackAutoEnrollmentAcceptance: () => Promise<void>
}

export const useCashbackAutoEnrollmentController = (): ICashbackAutoEnrollmentController => {
  const {startLoading, stopLoading} = useLoader()
  const { handleMetaResponse } = useMetaResponseHandler()
  const { userName } = useUserData()

  const initCashbackAutoEnrollmentAcceptance = async (): Promise<void> => {
    startLoading()

    const response = await CashbackRepositoryAPI().startTransaction(userName)

    if (handleMetaResponse(response?.meta, undefined, { notifySuccess: false })) {
      if (response.meta.status === MetaStatusCodes.SUCCESS && response.data) {
        // logout
        await logoutWithoutRedirect()
        // create and submit form
        const logaltyFormHTML = createForm(response.data);
        if(logaltyFormHTML) {
          const formContainer = document.createElement("div");
          formContainer.innerHTML = logaltyFormHTML;
          document.body.appendChild(formContainer);
          document.forms[0].submit();
        }
      }

      stopLoading()
    }
  }  

  const createForm = (logalty: LogaltyModel): string | undefined => {
    if (!logalty?.signUrl || !logalty?.signSAML) {
      console.error('Logalty details are missing')
      return undefined
    }

    const formHTML = `
      <form method="post" action="${logalty.signUrl}">
        <input type="hidden" name="saml_assertion" value="${encodeURIComponent(atob(logalty.signSAML))}">
      </form>
    `

    return formHTML
  }

  const logoutWithoutRedirect = async (): Promise<void> => {
    await axiosFetch(logout, HttpMethod.POST).then(() => {
      sessionStorage.clear()
      localStorage.clear()
    })
  }

  return {
    initCashbackAutoEnrollmentAcceptance
  }
}